import Resizer from "react-image-file-resizer";

export const resizeImg = (file, fileType, width = 1000, height = 1000) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width,
      height,
      fileType.toUpperCase(),
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
      width,
      height
    );
  });
